// extracted by mini-css-extract-plugin
export default {"card":"Callback_card__t2EzT","spinner":"Callback_spinner__MijSd","error":"Callback_error__U6fyL","spin":"Callback_spin__pu8-E","content":"Callback_content__5ixLT"};